import { render } from "./CyberSocialSecurityView.vue?vue&type=template&id=1b7b8f2f&scoped=true"
import script from "./CyberSocialSecurityView.vue?vue&type=script&lang=js"
export * from "./CyberSocialSecurityView.vue?vue&type=script&lang=js"

import "./CyberSocialSecurityView.vue?vue&type=style&index=0&id=1b7b8f2f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7b8f2f"]])

export default __exports__